// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3Q0Y4","modal-content":"Modal_modal-content__3xq5u","close":"Modal_close__1oAua"};